const distribution = Object.freeze({
  Identical: "Identical",
  EvenlySpread: "Evenly Spread",
  ProportionallyFromForecast: "Proportionally From Forecast",
});

export default distribution;
